import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addProduct, retrieveCart } from '../state/ducks/cart'
import { loadHoneymoon, changePriceOrder } from '../state/ducks/honeymoon'
import withPage from '../hoc/page'
import Products from '../components/Products'

function Honeymoon({
  data: {
    body: { subtitle },
  },
  honeymoon,
  cartItems,
  order,
  settings,
  ...custom
}) {
  useEffect(() => {
    custom.retrieveCart()
    custom.loadHoneymoon()
  }, [])

  return (
    <>
      <Products
        title={subtitle}
        data={honeymoon}
        domain={`${settings.host}`}
        cartItems={cartItems}
        activeOrder={order}
        handleAddProduct={custom.addProduct}
        handleOrder={custom.changePriceOrder}     
        giftsAvailable={settings.settings.giftsAvailable}   
        redirectToPage = {settings.settings.redirectTo}
      />
    </>
  )
}

const mapStateToProps = state => ({
  honeymoon: state.honeymoon.list,
  order: state.honeymoon.priceSort,
  cartItems: state.cart.items,  
})

const mapDispatchToProps = dispatch => bindActionCreators({
  loadHoneymoon,
  retrieveCart,
  changePriceOrder,
  addProduct,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(
  withPage(Honeymoon, 'honeymoon'),
)
